import { marker } from '@biesbjerg/ngx-translate-extract-marker';

export * from './paid-payout-all/paid-payout-all.component';
export * from './paid-payout-all/paid-payout-transaction/paid-payout-transaction.component';
export * from './paid-payout-monthly/paid-payout-monthly-details/paid-payout-monthly-details.component';
export * from './paid-payout-monthly/paid-payout-monthly-transaction/paid-payout-monthly-transaction.component';
export * from './paid-payout-monthly/paid-payout-monthly.component';
export * from './paid-payout-ondemand/paid-payout-ondemand.component';

import { Route } from '@angular/router';








export const Routing: Route[] = [
  {
    path: 'payout/paid-payout',
    redirectTo: 'payout/paid-payout/all',
    pathMatch: 'full',
  },
  {
    path: 'payout/paid-payout/all',
    loadComponent: () => import('./paid-payout-all/paid-payout-all.component').then(m => m.PaidPayoutAllComponent),
    data: { title: marker('E-Commerce'), breadcrumb: 'Paid Payout' },
  },
  {
    path: 'payout/paid-payout/:payoutId/all',
    loadComponent: () => import('./paid-payout-all/paid-payout-transaction/paid-payout-transaction.component').then(m => m.PaidPayoutTransactionComponent),
    data: { title: marker('E-Commerce'), breadcrumb: 'Payout All Transaction' },
  },
  {
    path: 'payout/paid-payout/ondemand',
    loadComponent: () => import('./paid-payout-ondemand/paid-payout-ondemand.component').then(m => m.PaidPayoutOndemandComponent),
    data: { title: marker('E-Commerce'), breadcrumb: 'Paid Payout Ondemand' },
  },
  {
    path: 'payout/paid-payout/:payoutId/ondemand',
    loadComponent: () => import('./paid-payout-all/paid-payout-transaction/paid-payout-transaction.component').then(m => m.PaidPayoutTransactionComponent),
    data: { title: marker('E-Commerce'), breadcrumb: 'Payout Ondemand Transaction' },
  },
  {
    path: 'payout/paid-payout/monthly',
    loadComponent: () => import('./paid-payout-monthly/paid-payout-monthly.component').then(m => m.PaidPayoutMonthlyComponent),
    data: { title: marker('E-Commerce'), breadcrumb: 'Paid Payout Monthly' },
  },
  {
    path: 'payout/paid-payout/monthly/:payoutId/details',
    loadComponent: () => import('./paid-payout-monthly/paid-payout-monthly-details/paid-payout-monthly-details.component').then(m => m.PaidPayoutMonthlyDetailsComponent),
    data: { title: marker('E-Commerce'), breadcrumb: 'Paid Payout Monthly Details' },
  },
  {
    path: 'payout/paid-payout/monthly/:payoutId/transaction',
    loadComponent: () => import('./paid-payout-monthly/paid-payout-monthly-transaction/paid-payout-monthly-transaction.component').then(m => m.PaidPayoutMonthlyTransactionComponent),
    data: { title: marker('E-Commerce'), breadcrumb: 'Paid Payout Monthly Transaction' },
  },
];
